import React, { useEffect, useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';

interface Props {
    onFileChange?: Function
}

export default function UploadButton(props: any) {
    const inputFile = useRef(null);
    function click(e: any){
        (inputFile.current as any).click();
    }
    return (
        <>
            <input type='file' id='file' accept="video/*" onChange={props.onFileChange as any} ref={inputFile} style={{ display: 'none' }} />
            <Button variant="primary" onClick={click} className="youclip-upload-btn">Upload New Clip</Button>
        </>
    )

}